//import {BrowserRouter as Router, Route} from "react-router-dom";
import {BrowserRouter as Router, Routes, Route, Navigate} from "react-router-dom";
// import Home from "./components/access.component";\
import { lazy, Suspense } from "react";
import useToken from './useToken';

// import Home from "./pages/Home";
const Home = lazy(() => import("./components/access.component"));

//Admin
const AllergyList = lazy(() => import("./components/admin_fronteditors/allergies-list.component"));
const EditAllergy = lazy(() => import("./components/admin_fronteditors/edit-allergy.component"));
const NotesList = lazy(() => import("./components/admin_todo/notes-list.component"));
const EditNote = lazy(() => import("./components/admin_todo/edit-note.component"));
const AdminRecipie = lazy(() => import("./components/admin_fronteditors/admin-recipie.component"));
const EditRecipie = lazy(() => import("./components/admin_fronteditors/edit-recipie.component"));
const BlogPost = lazy(() => import("./components/admin_fronteditors/blogposts.component"));

//CRM
const CRM = lazy(() => import("./components/admin_crm/crm.component"));
const CRML = lazy(() => import("./components/admin_crm/crm-loc.component"));
const CRMR = lazy(() => import("./components/admin_crm/reach-user.component"));
const FlightPlanner = lazy(() => import("./components/admin_travel/flight-planner.component"));

//Test
// import Scan from "./components/testing/scan.component"

function App() {  
  const token = useToken();

	// const getUser = async () => {
	// 	try {
	// 		const url = process.env.REACT_APP_API_URL+`/auth/login/success`;
	// 		const { data } = await axios.get(url, { withCredentials: true });
	// 		setUser(data.user._json);
	// 	} catch (err) {
	// 		console.log(err);
	// 	}
	// };

	// useEffect(() => {
	// 	getUser();
	// }, []);

  return (

    <Router>

			<Suspense fallback={<div />}>
			<Routes>
			{ token ? ( <>
		{/* <Route
					exact
					path="/"
					element={<Home user={user} />}
				/> */}
      <Route path="/" element={<Navigate to="/notes" />} />
      <Route path="/notes/edit/:id" exact element={<EditNote/>}/>
      <Route path="/notes" exact element={<NotesList/>}/>
      <Route path="/allergies/allergieslist" exact element={<AllergyList/>}/>
      <Route path="/allergies/edit/:id" exact element={<EditAllergy/>}/>
      <Route path="/recipies/" exact element={<AdminRecipie/>}/>
      <Route path="/recipies/edit/:id" exact element={<EditRecipie/>}/>  
      <Route path="/blogs/" exact element={<BlogPost/>}/>
      <Route path="/crm" exact element={<CRM/>}/>
      <Route path="/loci" exact element={<CRML/>}/>
      <Route path="/texter" exact element={<CRMR/>}/>
	<Route path="/flights" exact element={<FlightPlanner/>}/>
      </>
      ):
      <>
      <Route path="/" exact element={<Home/>}/>
			
				{/* <Route
					exact
					path="/login"
					element={user ? <Navigate to="/" /> : <Login />}
				/>
				<Route
					path="/signup"
					element={user ? <Navigate to="/" /> : <Signup />}
				/> */}
     </> }
    </Routes>
    </Suspense>
  
    </Router>
    
  );
}

export default App;
